export const deleteNCRFromCache = (cache, { data }) => {
    cache.evict({ id: cache.identify({ __typename: 'NCR', _id: data.updateNCR.ncr._id }) });
};
